
<template>
  <div>
    <span class="logo-system" v-if="($vuetify.breakpoint.width > 1485 || $vuetify.breakpoint.width < 1264) && !text">GESTÃO</span>
    <v-btn v-if="!text" icon @click="dialog = !dialog" class="mr-3 ml-1"><v-icon large >mdi-swap-horizontal</v-icon></v-btn>
    <v-btn v-if="text" text @click="dialog = !dialog" class="white--text">
      <v-icon large left>mdi-swap-horizontal</v-icon>
      <span class="ml-2">Voltar ao sistema</span>
    </v-btn>
    <v-dialog v-model="dialog" persistent transition="slide-x-transition" max :width="$vuetify.breakpoint.width > 600 ? '50%' : '90%'">
      <v-card elevation="3" class="">
        <v-card-title class="headline" style="word-break: break-word">
          Escolha um sistema
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6" class="d-flex align-center">
              <v-img contain max-height="50" :src="logo"></v-img>
              <v-divider vertical></v-divider>
            </v-col>
            <v-col cols="12" md="6" >
              <div v-for="btn in URL_MAP">
                <v-btn block :color="btn.color" class="my-3" @click="btn.function(btn.link)" dark> 
                  <v-icon left>{{btn.icon}}</v-icon> 
                  {{ btn.label }}
                </v-btn>
              </div>
            </v-col>
            
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Logo from "@/assets/logos/cimentao.png";
import cimentao_links from "@/mixins/cimentao_links";
export default {
  name: 'ChangeSystems',
  mixins: [ cimentao_links ],
  props:{
    text: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      dialog: false,
      logo: Logo,
    }
  },
}
</script>

<style scoped>
.logo-system{
  position: absolute;
  margin: 34px 0px 0px 115px !important; 
  color: rgb(114, 114, 114); font-size: 11px !important; 
  text-decoration: none !important; 
  z-index: 0 !important;
}
</style>